// --------- Pagination ------------------
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_ROWS_PER_PAGE = [DEFAULT_PAGE_SIZE, 50, 100];
